'use client';

import { c as _c } from "react/compiler-runtime";
import ProductMetadata from '@classify/react-product-components/ProductMetadata';
import ProductMetadataDuration from '@classify/react-product-components/ProductMetadataDuration';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import EasyIcon from '../images/EasyIcon';
import MediumIcon from '../images/MediumIcon';
import HardIcon from '../images/HardIcon';
type Props = {
  course: {
    displayDifficulty?: string;
    difficulty?: 'Easy' | 'Medium' | 'Hard' | string;
    duration?: string;
  };
};
export default function CourseMetadata(t0) {
  const $ = _c(13);
  const {
    course
  } = t0;
  let t1;
  if ($[0] !== course) {
    t1 = course || {};
    $[0] = course;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    displayDifficulty,
    difficulty,
    duration
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      Easy: EasyIcon,
      Medium: MediumIcon,
      Hard: HardIcon
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const iconsPerDifficulty = t2;
  const difficultyIcon = iconsPerDifficulty[difficulty || ""] || HardIcon;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      durationMonths: _temp,
      durationHours: _temp2,
      durationMinutes: _temp3
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const translations = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "row",
      gap: 3
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== difficultyIcon || $[6] !== displayDifficulty) {
    t5 = displayDifficulty && <ProductMetadata icon={difficultyIcon} shouldNotWrap={true} accessibilityLabel={translate("courses.accessibility_labels.difficulty")}>{displayDifficulty}</ProductMetadata>;
    $[5] = difficultyIcon;
    $[6] = displayDifficulty;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== duration) {
    t6 = duration && <ProductMetadataDuration shouldNotWrap={true} duration={duration} translations={translations} accessibilityLabel={translate("learning_content.duration.hours.accessibility_label")} />;
    $[8] = duration;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Box sx={t4}>{t5}{t6}</Box>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp3(count_1) {
  return translate("learning_content.duration.minutes", {
    count: count_1
  }, count_1);
}
function _temp2(count_0) {
  return translate("learning_content.duration.hours", {
    count: count_0
  }, count_0);
}
function _temp(count) {
  return translate("learning_content.duration.months", {
    count
  }, count);
}